import forge from 'node-forge';

const ForgeLib = {
  encryptData(publicKeyIn, pwd) {
    const publicEncryptionKey = publicKeyIn;
    const decodePublicKey = forge.util.decode64(publicEncryptionKey);
    const publicKey = forge.pki.publicKeyFromPem(decodePublicKey);
    const encrypted = publicKey.encrypt(pwd);
    const base64Encrypted = forge.util.encode64(encrypted);
    return base64Encrypted;
  },
  encryptRSA(publicEncryptionKey, pin) {
    const { rsa } = forge.pki;
    const { pki } = forge;
    const decodePublicKey = forge.util.decode64(publicEncryptionKey);
    const publicKey = forge.pki.publicKeyFromPem(decodePublicKey);
    const encrypted = publicKey.encrypt(pin, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
    });

    const base64Encrypted = forge.util.encode64(encrypted);
    return base64Encrypted;
  },
};

export default ForgeLib;
